window.Nette = {
    noInit: true
};
